/// <reference types="@angular/localize" />
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { AppRoutingModule } from './app/app-routing.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DpDatePickerModule } from 'ng2-date-picker';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { LoaderInterceptor } from './app/loader/loader.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { AuthInterceptor } from './app/services/auth-interceptor.service';
import { enforceTenantIntegrity } from './app/shared/tenant.util';


// Block manually-tampered tenant URLs before the app boots (while ?token= is
// still present). Redirects to the portal's unauthorized page on mismatch.
if (enforceTenantIntegrity()) {
  bootstrapApplication(AppComponent, {
      providers: [
          importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule, CommonModule, DpDatePickerModule, NgbModule, DragDropModule, AngularEditorModule, AppRoutingModule, NgxGraphModule, NgMultiSelectDropDownModule),
          {
              provide: HTTP_INTERCEPTORS,
              useClass: LoaderInterceptor,
              multi: true,
          },
          provideAnimations(),
          provideHttpClient(withInterceptorsFromDi()),
          { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      ]
  })
    .catch(err => console.error(err));
}
